import Profile from '../../modules/hospital/profile/Profile';
import Calender from '../../modules/hospital/calender/Calendar';
import Documents from '../../modules/hospital/documents/Documents';
import Infrastructure from '../../modules/hospital/profile/details/Infrastructure/Infrastructure';
import HospitalDetails from '../../modules/hospital/profile/details/hospitalDetails/HospitalDetails';
import AccountDetail from '../../modules/hospital/profile/details/accountDetail/AccountDetail';
import Doctors from '../../modules/inventry/doctors/Doctors';
import HealthCheck from '../../modules/inventry/healthCheck/HealthCheck';
import DoctorsList from '../../modules/inventry/doctors/doctorsList/DoctorsList';
import DoctorProfile from '../../modules/inventry/doctors/doctorProfile/DoctorProfile';
import NewDoctorProfile from '../../modules/inventry/doctors/newDoctorProfile/NewDoctorProfile';
import EditDoctorProfile from '../../modules/inventry/doctors/newDoctorProfile/EditDoctorProfile';
import HealthCheckPackageDetail from '../../modules/inventry/healthCheck/detail/HealthCheckPackageDetail';
import HealthCheckPackages from '../../modules/inventry/healthCheck/list/HealthCheckPackages';
import NewHealthCheckPackage from '../../modules/inventry/healthCheck/detail/NewHealthCheckPackage';
import EditHealthCheckPackage from '../../modules/inventry/healthCheck/detail/EditHealthCheckPackage';
import InPatient from '../../modules/inventry/ipPackages/InPatient';
import EditIPPackage from '../../modules/inventry/ipPackages/detail/EditIPPackage';
import NewIPPackage from '../../modules/inventry/ipPackages/detail/NewIPPackage';
import EditLabTestPackage from '../../modules/inventry/labTests/detail/EditLabTestPackage';
import LabTest from '../../modules/inventry/labTests/LabTest';
import IPPackages from '../../modules/inventry/ipPackages/list/IPPackages';
import DaycareServices from '../../modules/inventry/daycareServices/DaycareServices';
import DaycarePackages from '../../modules/inventry/daycareServices/daycareList/DaycarePackages';
import DaycarePackageDetail from '../../modules/inventry/daycareServices/daycareDetail/DaycarePackageDetail';
import NewDaycarePackage from '../../modules/inventry/daycareServices/daycareDetail/NewDaycarePackage';
import EditDaycarePackage from '../../modules/inventry/daycareServices/daycareDetail/EditDaycarePackage';
import IPPackageDetail from '../../modules/inventry/ipPackages/detail/IPPackageDetail';
import LabTests from '../../modules/inventry/labTests/list/LabTests';
import Guidelines from '../../modules/resources/guidelines/Guidelines';
import Help from '../../modules/resources/help/Help';
import NewsAndAnnouncements from '../../modules/resources/newsAndAnnouncements/NewsAndAnnouncements';
import InPatientList from '../../modules/crm/inPatient/InPatient';
import { authFeatureConstants, NOTREQUIRED } from '../../shared/constants/commonConstants';
import Mailbox from '../../modules/hospital/mailbox/Mailbox';
import Blogs from '../../modules/resources/blogs/Blogs';
import FootfallTrends from '../../modules/Dashboard/FootfallTrends';
import AccountReceivables from '../../modules/Dashboard/AccountReceivables';
import TurnaroundTime from '../../modules/Dashboard/TurnaroundTime';
import Corporate from '../../modules/Dashboard/Corporate';
import GrievanceDetail from '../../modules/grievance/ViewSection/GrievanceDetail';
import ViewGrievance from '../../modules/grievance/ViewSection/ViewGrievance';
import RaiseGrievance from '../../modules/grievance/RaiseSection/RaiseGrievance';
import GrievanceList from '../../modules/grievance/ViewSection/ViewGrievanceList_New';
import ClaimList from '../../modules/grievance/RaiseSection/ClaimList';
import NewGrievance from '../../modules/grievance/RaiseSection/NewGrievance';
import Summary from '../../modules/Dashboard/Summary';
import Specialty from '../../modules/Dashboard/Specialty';
import CostOfCareFinder from '../../modules/costOfCare/CostOfCareFinder';
// import PackageCostFinder from '../../modules/costOfCare/PackageCostFinder';
import NewAdmissionReimbursement from '../../modules/reimbursement/home/newAdmission/NewAdmissionReimbursement';
import Home from '../../modules/reimbursement/home/Home';
import List from '../../modules/reimbursement/home/list/List';
import ReconciliationList from '../../modules/reconciliation/reconciliationNew/components/List/ReconciliationList';
import ReimbursementDetail from '../../modules/reimbursement/home/detail/ReimbursementDetail';
import EditReimbursement from '../../modules/reimbursement/home/edit/EditReimbursement';
import ReconciliationNew from '../../modules/reconciliation/reconciliationNew/ReconciliationNew';
import ReconciliationTATReport from '../../modules/reconciliation/ReconciliationTATReport/ReconciliationTATReport';
import ReconciliationClaimDetail from '../../modules/reconciliation/reconciliationNew/components/ReconciliationClaimDetail';
import TdsConfigurationPage from '../../modules/reconciliation/reconciliationNew/components/cards/TdsConfigurationPage';
import CompareCenter from '../../modules/Dashboard/CompareCenter';
import ReconcilationTurnaroundTime from '../../modules/reconciliation/ReconciliationTATReport/ReconcilationTurnaroundTime';
import ConfiguredPayerList from '../../modules/hospital/mailbox/ConfiguredPayerList';
import HospitalConfiguration from '../../modules/hospital/mailbox/HospitalConfiguration';
import OnboardingNhcx from '../../modules/hospital/nhcx/OnboardingNhcx';
import TickerConfiguration from '../../modules/configurator/tickerConfigurator/TickerConfiguration';
import InboundProviderIdsConfigurator from '../../modules/configurator/inboundProviderIdsConfigurator/InboundProviderIdsConfigurator';
import MergeDeMergeClaimsConfigurator from '../../modules/configurator/mergeDeMergeClaimsConfigurator/MergeDeMergeClaimsConfigurator';
import HospitalSealComponent from '../../modules/inventry/hospitalSeal/HospitalSealComponent';
import TransactionTatReport from '../../modules/reportingAndAnalytics/TransactionTatReport';
import AdoptionReport from '../../modules/reportingAndAnalytics/AdoptionReport';
import TransactionCountReport from '../../modules/reportingAndAnalytics/TransactionCountReport/TransactionCountReport';

export const HOSPITAL_NESTED_ROUTE_WITHOUT_MAILBOX_CONFIG = [
  {
    tabName: 'Hospital Profile',
    routeName: 'hospital-profile',
    Component: Profile,
    accessCheckKeyword: NOTREQUIRED,
  },
  {
    tabName: 'Calendar',
    routeName: 'calendar',
    Component: Calender,
    accessCheckKeyword: NOTREQUIRED,
  },
  {
    tabName: 'Documents',
    routeName: 'documents',
    Component: Documents,
    accessCheckKeyword: NOTREQUIRED,
  },
];
export const HOSPITAL_NESTED_ROUTE = [
  {
    tabName: 'Hospital Profile',
    routeName: 'hospital-profile',
    Component: Profile,
    accessCheckKeyword: NOTREQUIRED,
  },
  {
    tabName: 'Calendar',
    routeName: 'calendar',
    Component: Calender,
    accessCheckKeyword: NOTREQUIRED,
  },
  {
    tabName: 'Documents',
    routeName: 'documents',
    Component: Documents,
    accessCheckKeyword: NOTREQUIRED,
  },
  {
    tabName: 'Manage Configuration',
    routeName: 'mailbox',
    Component: Mailbox,
    accessCheckKeyword: NOTREQUIRED,
  },
  {
    tabName: 'NHCX Onboarding',
    routeName: 'nhcxUserCreation',
    Component: OnboardingNhcx,
    accessCheckKeyword: NOTREQUIRED,
  },
];
export const REPORT_ANALYTICS_MODULE = [
  {
    tabName: 'Transaction Count Report',
    routeName: 'transaction-count-report',
    Component: TransactionCountReport,
    accessCheckKeyword: authFeatureConstants.TRANSACTION_COUNT_REPORT,
  },
  {
    tabName: 'Transaction TAT Report',
    routeName: 'transaction-tat-report',
    Component: TransactionTatReport,
    accessCheckKeyword: NOTREQUIRED,
  },
  {
    tabName: 'Adoption Report',
    routeName: 'adoption-report',
    Component: AdoptionReport,
    accessCheckKeyword: NOTREQUIRED,
  },
];
export const HOSPITAL_NESTED_ROUTE_WITHOUT_NHCX = [
  {
    tabName: 'Hospital Profile',
    routeName: 'hospital-profile',
    Component: Profile,
    accessCheckKeyword: NOTREQUIRED,
  },
  {
    tabName: 'Calendar',
    routeName: 'calendar',
    Component: Calender,
    accessCheckKeyword: NOTREQUIRED,
  },
  {
    tabName: 'Documents',
    routeName: 'documents',
    Component: Documents,
    accessCheckKeyword: NOTREQUIRED,
  },
  {
    tabName: 'Manage Configuration',
    routeName: 'mailbox',
    Component: Mailbox,
    accessCheckKeyword: NOTREQUIRED,
  },
];
export const GRIEVANCE_ROUTE = [
  {
    tabName: 'Raise Grievance',
    routeName: 'raise',
    Component: RaiseGrievance,
    accessCheckKeyword: authFeatureConstants.EDIT_GRIEVANCE,
  },
  {
    tabName: 'View Grievances',
    routeName: 'view',
    Component: ViewGrievance,
    accessCheckKeyword: NOTREQUIRED,
  },
];

export const MAILBOX_ROUTE = [
  {
    tabName: 'Configure Payer',
    routeName: 'payer',
    Component: ConfiguredPayerList,
    accessCheckKeyword: NOTREQUIRED,
  },
  {
    tabName: 'Configure Hospital',
    routeName: 'hospital',
    Component: HospitalConfiguration,
    accessCheckKeyword: NOTREQUIRED,
  },
];

export const VIEW_GRIEVANCE_ROUTE = [
  {
    routeName: 'detail/:record/reply',
    Component: GrievanceDetail,
    accessCheckKeyword: NOTREQUIRED,
  },
  {
    routeName: 'detail/:record',
    Component: GrievanceDetail,
    accessCheckKeyword: NOTREQUIRED,
  },
  {
    routeName: '/',
    Component: GrievanceList,
    accessCheckKeyword: NOTREQUIRED,
  },
];

export const RAISE_GRIEVANCE_ROUTE = [
  {
    routeName: 'list',
    Component: ClaimList,
    accessCheckKeyword: NOTREQUIRED,
  },
  {
    routeName: 'new-grievance/:id',
    Component: NewGrievance,
    accessCheckKeyword: authFeatureConstants.EDIT_GRIEVANCE,
  },
];

export const HOSPITAL_PROFILE_NESTED_ROUTE = [
  {
    tabName: 'Basic Details',
    routeName: 'hospital-details',
    Component: HospitalDetails,
    accessCheckKeyword: NOTREQUIRED,
  },
  {
    tabName: 'Account Details',
    routeName: 'account-details',
    Component: AccountDetail,
    accessCheckKeyword: NOTREQUIRED,
  },
  {
    tabName: 'Infrastructure Details',
    routeName: 'infrastructure-details',
    Component: Infrastructure,
    accessCheckKeyword: NOTREQUIRED,
  },
];

export const INVENTORY_NESTED_ROUTE_DIGITIZATION = [
  {
    tabName: 'Hospital Seal',
    routeName: 'Hospital-seal',
    Component: HospitalSealComponent,
    accessCheckKeyword: NOTREQUIRED,
  },
  {
    tabName: 'Doctors',
    routeName: 'doctors',
    Component: Doctors,
    accessCheckKeyword: NOTREQUIRED,
  },
  {
    tabName: 'Health Check Packages',
    routeName: 'health-check-package',
    Component: HealthCheck,
    accessCheckKeyword: NOTREQUIRED,
  },
  {
    tabName: 'Lab Tests',
    routeName: 'lab-tests',
    Component: LabTest,
    accessCheckKeyword: NOTREQUIRED,
  },
  {
    tabName: 'IP Packages',
    routeName: 'ip-packages',
    Component: InPatient,
    accessCheckKeyword: NOTREQUIRED,
  },
  {
    tabName: 'Day Care Services',
    routeName: 'daycare-services',
    Component: DaycareServices,
    accessCheckKeyword: NOTREQUIRED,
  },
];

export const INVENTORY_NESTED_ROUTE = [
  {
    tabName: 'Doctors',
    routeName: 'doctors',
    Component: Doctors,
    accessCheckKeyword: NOTREQUIRED,
  },
  {
    tabName: 'Health Check Packages',
    routeName: 'health-check-package',
    Component: HealthCheck,
    accessCheckKeyword: NOTREQUIRED,
  },
  {
    tabName: 'Lab Tests',
    routeName: 'lab-tests',
    Component: LabTest,
    accessCheckKeyword: NOTREQUIRED,
  },
  {
    tabName: 'IP Packages',
    routeName: 'ip-packages',
    Component: InPatient,
    accessCheckKeyword: NOTREQUIRED,
  },
  {
    tabName: 'Day Care Services',
    routeName: 'daycare-services',
    Component: DaycareServices,
    accessCheckKeyword: NOTREQUIRED,
  },
];

export const INVENTORY_DOCTORS_NESTED_ROUTE = [
  {
    routeName: 'doctors-list',
    Component: DoctorsList,
    accessCheckKeyword: NOTREQUIRED,
  },
  {
    routeName: 'doctor-profile/:id',
    Component: DoctorProfile,
    accessCheckKeyword: NOTREQUIRED,
  },
  {
    routeName: 'new-doctor-profile',
    Component: NewDoctorProfile,
    accessCheckKeyword: authFeatureConstants.EDIT_DOCTORS,
  },
  {
    routeName: 'edit-doctor-profile/:id',
    Component: EditDoctorProfile,
    accessCheckKeyword: authFeatureConstants.EDIT_DOCTORS,
  },
];

export const CONFIGURATORS_NESTED_ROUTE = [
  {
    tabName: 'Ticker Configurator',
    routeName: 'tickerChange',
    Component: TickerConfiguration,
    accessCheckKeyword: authFeatureConstants.TICKER_CONFIGURATOR,
  },
  {
    tabName: 'Inbound Provider IDs Configurator',
    routeName: 'inboundProviderIds',
    Component: InboundProviderIdsConfigurator,
    accessCheckKeyword: authFeatureConstants.INBOUND_PROVIDER_ID_CONFIGURATOR,
  },
  {
    tabName: 'Merge & DeMerge Claims Configurator',
    routeName: 'mergeDeMergeClaims',
    Component: MergeDeMergeClaimsConfigurator,
    accessCheckKeyword: authFeatureConstants.MERGE_DEMERGE_CONFIGURATOR,
  },
];

export const RESOURCES_NESTED_ROUTE = [
  {
    tabName: 'Blogs',
    routeName: 'blogs',
    Component: Blogs,
    accessCheckKeyword: NOTREQUIRED,
  },
  {
    tabName: 'Guidelines',
    routeName: 'guidelines',
    Component: Guidelines,
    accessCheckKeyword: NOTREQUIRED,
  },
  {
    tabName: 'Help',
    routeName: 'help',
    Component: Help,
    accessCheckKeyword: NOTREQUIRED,
  },
  {
    tabName: 'News and Announcements',
    routeName: 'news-and-announcements',
    Component: NewsAndAnnouncements,
    accessCheckKeyword: NOTREQUIRED,
  },
];

export const INVENTORY_HEALTHCHECK_NESTED_ROUTE_DETAIL = [
  {
    routeName: 'healthcheck-packages',
    Component: HealthCheckPackages,
    accessCheckKeyword: NOTREQUIRED,
  },
  {
    routeName: 'healthcheck-package-detail/:id',
    Component: HealthCheckPackageDetail,
    accessCheckKeyword: NOTREQUIRED,
  },
  {
    routeName: 'new-healthcheck-packages',
    Component: NewHealthCheckPackage,
    accessCheckKeyword: authFeatureConstants.EDIT_HEALTH_CHECK_PACKAGES,
  },
  {
    routeName: 'edit-healthcheck-package/:id',
    Component: EditHealthCheckPackage,
    accessCheckKeyword: authFeatureConstants.EDIT_HEALTH_CHECK_PACKAGES,
  },
];

export const INVENTORY_IP_NESTED_ROUTE_DETAIL = [
  {
    routeName: 'ip-packages',
    Component: IPPackages,
    accessCheckKeyword: NOTREQUIRED,
  },
  {
    routeName: 'ip-package-detail/:id',
    Component: IPPackageDetail,
    accessCheckKeyword: NOTREQUIRED,
  },
  {
    routeName: 'new-ip-package',
    Component: NewIPPackage,
    accessCheckKeyword: authFeatureConstants.EDIT_IP_PACKAGES,
  },
  {
    routeName: 'edit-ip-package/:id',
    Component: EditIPPackage,
    accessCheckKeyword: authFeatureConstants.EDIT_IP_PACKAGES,
  },
];

export const INVENTORY_DAYCARE_NESTED_ROUTE_DETAIL = [
  {
    routeName: 'daycare-packages',
    Component: DaycarePackages,
    accessCheckKeyword: NOTREQUIRED,
  },
  {
    routeName: 'daycare-package-detail/:id',
    Component: DaycarePackageDetail,
    accessCheckKeyword: NOTREQUIRED,
  },
  {
    routeName: 'new-daycare-package',
    Component: NewDaycarePackage,
    accessCheckKeyword: authFeatureConstants.EDIT_DAY_CARE_SERVICES,
  },
  {
    routeName: 'edit-daycare-package/:id',
    Component: EditDaycarePackage,
    accessCheckKeyword: authFeatureConstants.EDIT_DAY_CARE_SERVICES,
  },
];
export const INVENTORY_LABTEST_NESTED_ROUTE_DETAIL = [
  {
    routeName: 'lab-tests',
    Component: LabTests,
    accessCheckKeyword: NOTREQUIRED,
  },
  {
    routeName: 'edit-labtest-packages/:groupId/:testId',
    Component: EditLabTestPackage,
    accessCheckKeyword: authFeatureConstants.EDIT_LAB_TESTS,
  },
];

export const RESOURCES_NESTED_ROUTE_DETAIL = [
  {
    routeName: 'guidelines',
    Component: Guidelines,
    accessCheckKeyword: NOTREQUIRED,
  },
  {
    routeName: 'help',
    Component: Help,
    accessCheckKeyword: NOTREQUIRED,
  },
];

export const CRM_NESTED_ROUTE = (): any => {
  return [
    {
      tabName: 'In-patient desk',
      routeName: 'in-patient',
      Component: InPatientList,
      accessCheckKeyword: NOTREQUIRED,
    },
  ];
};

export const DASHBOARD_NESTED_ROUTE = [
  {
    tabName: 'Compare Center',
    routeName: 'compare-center',
    Component: CompareCenter,
    accessCheckKeyword: authFeatureConstants.METRICS_BOARD_COMPARE_CENTER,
  },
  {
    tabName: 'Summary',
    routeName: 'summary',
    Component: Summary,
    accessCheckKeyword: authFeatureConstants.METRICS_BOARD_SUMMARY,
  },
  {
    tabName: 'Footfall Trends',
    routeName: 'footfall-trends',
    Component: FootfallTrends,
    accessCheckKeyword: authFeatureConstants.METRICS_BOARD_FOOTFALL_TRENDS,
  },
  {
    tabName: 'Account Receivables',
    routeName: 'account-receivables',
    Component: AccountReceivables,
    accessCheckKeyword: authFeatureConstants.METRICS_BOARD_ACCOUNT_RECEIVABLE,
  },
  {
    tabName: 'Turnaround Time',
    routeName: 'turnaround-time',
    Component: TurnaroundTime,
    accessCheckKeyword: authFeatureConstants.METRICS_BOARD_TURNAROUND_TIME,
  },
  {
    tabName: 'Corporate ',
    routeName: 'corporate',
    Component: Corporate,
    accessCheckKeyword: authFeatureConstants.METRICS_BOARD_CORPORATE,
  },
  {
    tabName: 'Specialty ',
    routeName: 'specialty',
    Component: Specialty,
    accessCheckKeyword: authFeatureConstants.METRICS_BOARD_SPECIALITY,
  },
];

export const COST_OF_CARE_NESTED_ROUTE = [
  // {
  //   tabName: 'Package Cost Finder',
  //   routeName: 'package-cost-finder',
  //   dashboardType: 'PackageCostFinder',
  //   Component: PackageCostFinder,
  //   accessCheckKeyword: NOTREQUIRED,
  // },
  {
    tabName: 'Cost of Care Finder',
    routeName: 'cost-of-care-finder',
    dashboardType: 'CostOfCareFinder',
    Component: CostOfCareFinder,
    accessCheckKeyword: NOTREQUIRED,
  },
];
export const REIMBURSEMENT_HOME_NESTED_ROUTE = (): any[] => [
  {
    tabName: 'List',
    routeName: 'list',
    Component: List,
    accessCheckKeyword: NOTREQUIRED,
  },
  {
    tabName: 'New Admission',
    routeName: 'new-admission',
    Component: NewAdmissionReimbursement,
    accessCheckKeyword: NOTREQUIRED,
  },
  {
    tabName: 'Edit',
    routeName: 'edit/:data',
    Component: EditReimbursement,
    accessCheckKeyword: NOTREQUIRED,
  },
  {
    tabName: 'Detail',
    routeName: 'detail/:data',
    Component: ReimbursementDetail,
    accessCheckKeyword: NOTREQUIRED,
  },
];
export const REIMBURSEMENT_NESTED_ROUTE = (): any => {
  return [
    {
      tabName: 'Home',
      routeName: 'home',
      Component: Home,
      accessCheckKeyword: NOTREQUIRED,
    },
  ];
};

export const RECONCILIATION_ROUTE = process.env.REACT_APP_IS_RECONCILIATION_NEW_ENABLED === 'true' ?
  [
    {
      tabName: 'Reconciliation 2.0',
      routeName: 'reconciliation-new',
      Component: ReconciliationNew,
      accessCheckKeyword: NOTREQUIRED,
    },
    {
      tabName: 'Reconciliation',
      routeName: 'recon-tat-report',
      Component: ReconciliationTATReport,
      accessCheckKeyword: NOTREQUIRED,
    },
    {
      tabName: 'Turnaround Time',
      routeName: 'tat-report',
      Component: ReconcilationTurnaroundTime,
      accessCheckKeyword: NOTREQUIRED,
    },
  ]
  :
  [
    {
      tabName: 'Reconciliation',
      routeName: 'recon-tat-report',
      Component: ReconciliationTATReport,
      accessCheckKeyword: NOTREQUIRED,
    },
    {
      tabName: 'Turnaround Time',
      routeName: 'tat-report',
      Component: ReconcilationTurnaroundTime,
      accessCheckKeyword: NOTREQUIRED,
    },
  ];

export const RECONCILIATION_NESTED_ROUTE = (): any[] => [
  {
    tabName: 'Detail',
    routeName: 'detail/:data',
    Component: ReconciliationClaimDetail,
    accessCheckKeyword: NOTREQUIRED,
  },
  {
    tabName: 'TDS Configuration',
    routeName: 'tds-configure',
    Component: TdsConfigurationPage,
    accessCheckKeyword: NOTREQUIRED,

  },
  {
    tabName: 'List',
    routeName: '/',
    Component: ReconciliationList,
    accessCheckKeyword: NOTREQUIRED,
  },
];
